/* -------------------- start-teaching Endpoints -------------------- */
import { Cache } from 'axios-extensions'
import { minuteToMilliSecond } from '@helper/utils'
export const START_TEACHING_LANDING = { url: 'www/v1/start-teaching/landing', cache: cache(30) }
export const BEST_TEACHERS = '/www/v1/start-teaching/landing/best-teachers'
export const EMAIL_REGISTRATION = '/www/v1/start-teaching/landing/register'
export const STEP_PERSONAL_INFO = '/www/v1/start-teaching/steps/personal-info'
export const STEP_LANGUAGES = '/www/v1/start-teaching/steps/languages'
export const STEP_TEACHING_COURSES = '/www/v1/start-teaching/steps/teaching-courses'
export const STEP_TEACHING_PRICE = '/www/v1/start-teaching/steps/teaching-price'
export const STEP_EDUCATION_DEGREES = '/www/v1/start-teaching/steps/education-degrees'
export const STEP_WORK_EXPERIENCES = '/www/v1/start-teaching/steps/work-experiences'
export const STEP_CERTIFICATES = '/www/v1/start-teaching/steps/certificates'
export const STEP_PROFILE_PICTURE = '/www/v1/start-teaching/steps/profile-picture'
export const STEP_TEACHER_ABOUT = '/www/v1/start-teaching/steps/teacher-about'
export const STEP_INTRO_VIDEO = '/www/v1/start-teaching/steps/intro-video'
export const STEP_WORK_TIME = '/www/v1/start-teaching/steps/worktimes'
export const STEP_DOCUMENTS = '/www/v1/start-teaching/steps/documents'
export const UPLOAD_DOCUMENTS = '/www/v1/start-teaching/steps/documents/upload'
export const REMOVE_DOCUMENTS = '/www/v1/start-teaching/steps/documents/remove'
export const STEP_TACKING = '/www/v1/start-teaching/steps/tracking'
export const CHECK_YOUTUBE_LINK = '/www/v1/start-teaching/steps/intro-video/check-youtube-link'

function cache (time) {
  return new Cache({ ttl: minuteToMilliSecond(time), size: 5000, ttlAutopurge: true })
}
